import { Redirect } from 'react-router-dom';
// import { useSelector } from "react-redux";
const ProtectedRoute = ({ component: Component }) => {
  // const Component = this.props.Component;
  const isAuthenticated = sessionStorage.getItem('jwtToken');
  
  return isAuthenticated ? <Component /> : <Redirect to={{ pathname: '/' }} />;
};



// const ProtectedRoute = ({ component: Component, ...rest }) => {
  // const loginAuth = useSelector(state => state.login)
  // const isAuthenticated = sessionStorage.getItem('jwtToken');
  
  //   return (
    
//     < Route {...rest} render={props => (
//       isAuthenticated ?
//         (<Component {...props} />)
//         :
//         (
//           <Redirect to={{
//             pathname: '/login',
//             state: { from: props.location }
//           }}
//           />
//         )
//     )}
//     />
//   )
// }

export default ProtectedRoute;